import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "form--nested" };
const _hoisted_2 = { class: "table table--condensed table--form" };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = {
    key: 0,
    class: "form__table-cell form__collection-item-button"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = { key: 0 };
const _hoisted_7 = { class: "form__collection-buttons" };
import { computed, ref, watch } from "vue";
import { clone, get } from "lodash";
import Icon from "../Icon.vue";
import FormLabel from "./FormLabel.vue";
import FormGroup from "./FormGroup.vue";
import { collectionItemPrefix, fieldPath } from "./fieldControls";
import { removeCollectionItemValidation } from "./formValidation";
import { useFieldControl } from "./useFieldControl";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FieldControlTable',
    props: {
        form: {},
        validation: {},
        field: {},
        fieldId: {},
        data: {},
        disabled: { type: Boolean },
        fieldPrefix: {}
    },
    emits: [
        'change',
        'focus',
        'blur',
    ],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const { fieldOptions, emitChange } = useFieldControl(props, emit, 'FieldControlTable');
        const innerFieldPrefix = computed(() => fieldPath(props.fieldPrefix, props.field.name));
        const addRemove = computed(() => !fieldOptions.value.disabled && fieldOptions.value.collectionAddRemove !== false);
        const items = ref([]);
        watch(() => props.data, data => {
            items.value = data ? clone(data) : [];
            items.value.forEach(initItem);
        }, { immediate: true });
        // nested forms of a row need an object (or array) to write into
        function initItem(item) {
            (props.field.fields || [])
                .filter(field => field.type === 'form' && (item[field.name] === null || item[field.name] === undefined))
                .forEach(field => item[field.name] = field.options?.collection ? [] : {});
        }
        function onFieldChange(field, index, data) {
            items.value[index][field.name] = data;
            emitChange(items.value);
        }
        function removeCollectionItem(index) {
            if (!fieldOptions.value.collection) {
                return;
            }
            // cells are not validated client-side, so (server-side) errors of the
            //   following rows have to move up with their rows
            items.value.splice(index, 1);
            removeCollectionItemValidation(props.validation, innerFieldPrefix.value, index);
            emitChange(items.value);
        }
        function createCollectionItem() {
            if (!fieldOptions.value.collection) {
                return;
            }
            const item = {};
            initItem(item);
            items.value.push(item);
            emitChange(items.value);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("table", _hoisted_2, [
                    (items.value.length > 0)
                        ? (_openBlock(), _createElementBlock("thead", _hoisted_3, [
                            _createElementVNode("tr", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.field.fields, (header) => {
                                    return (_openBlock(), _createElementBlock("th", {
                                        key: header.name,
                                        class: "form__table-header"
                                    }, [
                                        _createVNode(FormLabel, {
                                            form: __props.form,
                                            field: header,
                                            "field-id": __props.fieldId
                                        }, null, 8, ["form", "field", "field-id"])
                                    ]));
                                }), 128))
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    _cache[3] || (_cache[3] = _createTextVNode()),
                    _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.field.fields, (f) => {
                                    return (_openBlock(), _createElementBlock("td", {
                                        key: f.name,
                                        class: "form__table-cell"
                                    }, [
                                        _createVNode(FormGroup, {
                                            form: __props.form,
                                            field: f,
                                            "field-prefix": _unref(collectionItemPrefix)(innerFieldPrefix.value, index),
                                            "hide-label": true,
                                            data: _unref(get)(item, f.name),
                                            validation: __props.validation,
                                            onChange: ($event) => (onFieldChange(f, index, $event))
                                        }, null, 8, ["form", "field", "field-prefix", "data", "validation", "onChange"])
                                    ]));
                                }), 128)),
                                _cache[1] || (_cache[1] = _createTextVNode()),
                                (addRemove.value)
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_4, [
                                        _createElementVNode("a", {
                                            onClick: _withModifiers(($event) => (removeCollectionItem(index)), ["prevent"]),
                                            class: "button button--small",
                                            href: ""
                                        }, [
                                            _createVNode(Icon, { name: "trash-alt" })
                                        ], 8, _hoisted_5)
                                    ]))
                                    : _createCommentVNode("", true)
                            ]));
                        }), 128)),
                        _cache[2] || (_cache[2] = _createTextVNode()),
                        (addRemove.value)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                                _createElementVNode("td", _hoisted_7, [
                                    _createElementVNode("a", {
                                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (createCollectionItem()), ["prevent"])),
                                        class: "button button--small",
                                        href: ""
                                    }, [
                                        _createVNode(Icon, { name: "plus" })
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ])
            ]));
        };
    }
});
